import {AlarmActionsHeader} from "../utils/alarms-actions-ui.jsx";
import {Fragment} from "react";

const OccDataTable = ({data = [], name, className}) => {
  const rows = Array.isArray(data) ? data : [];
  return(
    <div className={[className, "w-full"].join(" ")}>
      <AlarmActionsHeader header={name}/>
      <div className="border border-[#505050] p-2">
        <table>
          <tbody>
          {rows.map((item, idx) =>
            <Fragment key={idx}>
              <tr className="text-[#505050]! text-[14px] bg-[#fafafa]">
                <th colSpan={1} className="border border-[#e7e7e7] border-collapse text-start">ID:</th>
                <td colSpan={11} className="border border-[#e7e7e7] border-collapse text-start">{item?.id ?? ""}</td>
              </tr>
              <tr className="text-black text-[14px] ">
                <th colSpan={2} className="border border-[#e7e7e7] border-collapse text-start">INÍCIO DO FATO</th>
                <td colSpan={2} className="border border-[#e7e7e7] border-collapse text-start">{item?.dt_ini ?? ""}</td>
                <th colSpan={2} className="border border-[#e7e7e7] border-collapse text-start">FIM DO FATO:</th>
                <td colSpan={2} className="border border-[#e7e7e7] border-collapse text-start">{item?.dt_end ?? ""}</td>
                <th colSpan={2} className="border border-[#e7e7e7] border-collapse text-start">CADASTRO:</th>
                <td colSpan={2} className="border border-[#e7e7e7] border-collapse text-start">{item?.dt_create ?? ""}</td>
              </tr>
              <tr className="text-[#505050]! text-[14px] bg-[#fafafa]">
                <th colSpan={1} className="border border-[#e7e7e7] border-collapse text-start">NATUREZA:</th>
                <td colSpan={11} className="border border-[#e7e7e7] border-collapse text-start">{item?.reasons ?? ""}</td>
              </tr>
              <tr className="text-black text-[14px] ">
                <th colSpan={3} className="border border-[#e7e7e7] border-collapse text-start">CLASSIFICAÇÃO</th>
                <td colSpan={3} className="border border-[#e7e7e7] border-collapse text-start">{item?.classification ?? ""}</td>
                <th colSpan={3} className="border border-[#e7e7e7] border-collapse text-start">MUNICÍPIO</th>
                <td colSpan={3} className="border border-[#e7e7e7] border-collapse text-start">{item?.local?.city ?? ""}</td>
              </tr>
              <tr className="text-[#505050]! text-[14px] bg-[#fafafa]">
                <th colSpan={1} className="border border-[#e7e7e7] border-collapse text-start">LOGRADOURO:</th>
                <td colSpan={11} className="border border-[#e7e7e7] border-collapse text-start">{item?.local?.address ?? ""}</td>
              </tr>
            </Fragment>
          )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default OccDataTable;